export default __webpack_public_path__ + "images/EP.32d6909.png";